import styled from 'styled-components';

export const FormGroup = styled.div`
  margin: auto;
  width: 100%;
  &.is-invalid {
    margin-bottom: auto !important;
  }
`;

export const FormGroupFlex = styled(FormGroup)`
  flex: ${({flex}) => flex ?? 1};
`

export const Label = styled.label`
  color: #707070;
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 8px;
`
